/*
 * @Author: zgz
 * @Date: 2020-11-26 15:29:18
 * @LastEditors: zgz
 * @LastEditTime: 2021-01-27 20:24:19
 * @Description:
 */
import request from "./axios.js";

var BGHttp = {};
// 各种接口
// 获取验证码
BGHttp.getVerifyCode = (params) => request("get", "/v1/Verify/send", params);
// 手机验证码登录
BGHttp.getPhoneLogin = (params) => request("get", "/v1/User/phone", params);
// 账号密码登录
BGHttp.getUserLogin = (params) => request("get", "/v1/User/login", params);
// 修改密码
BGHttp.modify = (params) => request("get", "/v1/User/modify", params);

// 存储用户数据
BGHttp.saveUserInfo = (data, type) => {
  localStorage.clear()
  localStorage.setItem("type", type);
  localStorage.setItem("data", JSON.stringify(data));
  localStorage.setItem("tx_id", data.tx_id);
  localStorage.setItem("token", data.token);
  localStorage.setItem("account", data.account);
  localStorage.setItem("password", data.password);
  localStorage.setItem("phone", data.phone);
  localStorage.setItem("time", new Date().getTime()); // 重新设置时间
};

BGHttp.loadUserInfo = (key) => {
  console.log(key)
  return localStorage.getItem(key);
}

// 获取token
BGHttp.getToken = () => {
  let token = BGHttp.loadUserInfo("token");
  if (token == null || token == undefined) {
    return false;
  }
  return token;
};

BGHttp.clearUserInfo = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("time");
}
export default BGHttp;



// WEBPACK FOOTER //
// ./src/components/common/axios/config.js